import React from 'react'
import { makeStyles } from '@material-ui/core/styles'


const useStyles = makeStyles((theme) => ({
    circle: {
        width: 78,
        height: 78,
        borderRadius: '50%',
        // border: `1px solid ${theme.palette.light.type2}`,
        border: `1px solid #0B1742`,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        margin : "auto"
    },
    borderWhite:{
        width: 75,
        height: 75,
        borderRadius: '50%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: '#DA212EAli',
        border: '3px solid white',
    },
    icon: {
        width: 37,
        height: 36
    },

}))

export default function Index({ id }) {

    const classes = useStyles()

    return (
        <div className={classes['circle']}>
            <div className={classes['borderWhite']}>
                <svg className={classes['icon']}>
                    <use xlinkHref={`/sprit.svg#${id}`} ></use>
                </svg>
            </div>
        </div>
    )
}
